import React from "react";
import { useState, useEffect } from "react";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { Form, Divider, Input, Select, InputNumber } from 'antd';
import EmployeeSearchBox from "../../../Components/EmployeeSearchBox";
import SupplierSearchBox from "../../../Components/SupplierSearchBox"
import { DataProvider } from "../../DataProvider";

const GeneralDetails = ({ formRef, disabled, initialValues }) => {

    const dataProvider = new DataProvider()

    const [mstLocation, setMstLocation] = useState([]);
    const [mstProgram, setMstProgram] = useState([]);
    const [mstProject, setMstProject] = useState([]);
    const [projectHeadFound, setProjectHeadFound] = useState(true);
    const [programHeadFound, setProgramHeadFound] = useState(true);

    const masterDataMapping = {
        "MstLocation": setMstLocation,
        "MstProgram": setMstProgram,
        "MstProject": setMstProject,
    };

    const fetchDropdownValues = () => {
        Object.keys(masterDataMapping).forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            const setter = masterDataMapping[model];
                            setter(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    const fetchDependentDropdownValues = (model, filter, value, callback) => {
        dataProvider.getDependentDropdownValues(model, filter + value).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    const setter = masterDataMapping[model];
                    setter(data.results)
                    callback(value)
                })
            } else {
                response.json().then((responseJson) => {
                    openNotification("error", "Error", responseJson["message"]);
                });
            }
        }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
    };


    useEffect(() => {
        fetchDropdownValues();
    }, []);

    const setProgramHead = (value) => {
        const selectedObj = mstProgram.filter(item => item.program_id == value)
        if (selectedObj['0']['program_head'].length > 0) {
            formRef.current.setFieldValue('program_head', JSON.parse(selectedObj['0']['program_head'])['label'])
            setProgramHeadFound(true)
        } else {
            setProgramHeadFound(false)
        }
    }

    const setProjectHead = (value) => {
        const selectedObj = mstProject.filter(item => item.project_id == value)
        if (selectedObj['0']['project_head'].length > 0) {
            formRef.current.setFieldValue('project_head', JSON.parse(selectedObj['0']['project_head'])['label'])
            setProjectHeadFound(true)
        } else {
            setProjectHeadFound(false)
        }
    }

    return (
        <>
            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"supplier"}
                    label="Supplier Name"
                    rules={[{ required: true, message: "Please enter Supplier Name" }]}>
                    <SupplierSearchBox
                        initialValues={initialValues}
                        formRef={formRef}
                        mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                        decorator="supplier"
                        disabled={disabled}
                        placeholder="Enter Supplier Name" />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="location" label="Location">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Location"
                        disabled={disabled}
                        optionFilterProp="label"
                        onSelect={(value) => fetchDependentDropdownValues('MstProgram', 'location.location_id=', value)}
                        options={mstLocation.map((val) => ({
                            value: val.location_id,
                            label: val.location_name,
                        }))} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="program" label="Program">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Program"
                        disabled={disabled}
                        optionFilterProp="label"
                        onSelect={(value) => fetchDependentDropdownValues('MstProject', 'program.program_id=', value, setProgramHead)}
                        options={mstProgram.map((val) => ({
                            value: val.program_id,
                            label: val.program_name,
                        }))} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                {programHeadFound ?
                    <Form.Item
                        name={"program_head"}
                        label="Program Head"
                        rules={[{ required: true, message: "Please enter Program Head" }]}>
                        <Input disabled={true} />
                    </Form.Item> :
                    <Form.Item
                        name={"program_head"}
                        label="Program Head"
                        rules={[{ required: true, message: "Please enter Program Head" }]}>
                        <EmployeeSearchBox
                            initialValues={initialValues}
                            formRef={formRef}
                            mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                            decorator="program_head"
                            disabled={disabled}
                            placeholder="Enter Program Head" />
                    </Form.Item>}

            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="project" label="Project">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Project"
                        disabled={disabled}
                        optionFilterProp="label"
                        onSelect={(value) => setProjectHead(value)}
                        options={mstProject.map((val) => ({
                            value: val.project_id,
                            label: val.project_name,
                        }))} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                {projectHeadFound ?
                    <Form.Item
                        name={"project_head"}
                        label="Project Head"
                        rules={[{ required: true, message: "Please enter Project Head" }]}>
                        <Input disabled={true} />
                    </Form.Item> :
                    <Form.Item
                        name={"project_head"}
                        label="Project Head"
                        rules={[{ required: true, message: "Please enter Project Head" }]}>
                        <EmployeeSearchBox
                            initialValues={initialValues}
                            formRef={formRef}
                            mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                            decorator="project_head"
                            disabled={disabled}
                            placeholder="Enter Project Head" />
                    </Form.Item>}
            </div>

        </>
    )
}

export default GeneralDetails;